import { inject, Injectable } from "@angular/core";
import { SuppliersAbstraction } from "../../../ports/abstractions";
import { environment } from "@environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { RespInterface, RespListInterface } from "@common/ports/interfaces";
import { PaymentSuppliersInterface, SuppliersInterface } from "../../../ports/interfaces";

@Injectable({
    providedIn: 'root'
})
export class SupplierRepository extends SuppliersAbstraction {
    /** Supplier */
    private readonly _baseUrlSupplierList: string = environment.baseUrlSupplierList;
    private readonly _baseUrlSupplierCreate: string = environment.baseUrlSupplierCreate;
    private readonly _baseUrlSupplierUpdate: string = environment.baseUrlSupplierUpdate;
    private readonly _baseUrlSupplierRead: string = environment.baseUrlSupplierRead;
    private readonly _baseUrlSupplierDelete: string = environment.baseUrlSupplierDelete;

    /** Payment Supplier */
    private readonly _baseUrlPaymentSupplierList: string = environment.baseUrlPaymentSupplierList;
    private readonly _baseUrlPaymentSupplierCreate: string = environment.baseUrlPaymentSupplierCreate;
    private readonly _baseUrlPaymentSupplierUpdate: string = environment.baseUrlPaymentSupplierUpdate;

    private http = inject(HttpClient);

    /** Supplier */
    override list(query: string): Observable<RespListInterface<SuppliersInterface>> {
        const url: string = this._baseUrlSupplierList;
        return this.http.get<RespListInterface<SuppliersInterface>>(`${url}/${query}`);
    }

    override create(supplier: SuppliersInterface): Observable<RespInterface<string>> {
        const url: string = this._baseUrlSupplierCreate;
        const { id, ...newSupplier } = supplier;
        return this.http.post<RespInterface<string>>(`${url}`, newSupplier);
    }

    override update(supplier: SuppliersInterface): Observable<RespInterface<string>> {
        const url: string = this._baseUrlSupplierUpdate;
        return this.http.patch<RespInterface<string>>(`${url}/${supplier.id}`, supplier);
    }

    override read(id: string): Observable<RespInterface<SuppliersInterface>> {
        const url: string = this._baseUrlSupplierRead;
        return this.http.get<RespInterface<SuppliersInterface>>(`${url}/${id}`);
    }

    override delete(id: string): Observable<RespInterface<SuppliersInterface>> {
        const url: string = this._baseUrlSupplierDelete;
        return this.http.delete<RespInterface<SuppliersInterface>>(`${url}/${id}`);
    }

    /** Payment Supplier */
    override listPaymentSupplier(query: string): Observable<RespListInterface<PaymentSuppliersInterface>> {
        const url: string = this._baseUrlPaymentSupplierList;
        return this.http.get<RespListInterface<PaymentSuppliersInterface>>(`${url}/${query}`);
    }

    override createPaymentSupplier(paymentSupplier: PaymentSuppliersInterface): Observable<RespInterface<string>> {
        const url: string = this._baseUrlPaymentSupplierCreate;
        const { id, ...newPaymentSupplier } = paymentSupplier;
        return this.http.post<RespInterface<string>>(`${url}`, newPaymentSupplier);
    }

    override updatePaymentSupplier(paymentSupplier: PaymentSuppliersInterface): Observable<RespInterface<string>> {
        const url: string = this._baseUrlPaymentSupplierUpdate;
        return this.http.patch<RespInterface<string>>(`${url}/${paymentSupplier.id}`, paymentSupplier);
    }

    override updatePaymentSupplierMasive(payload: { ids: string[] }): Observable<RespInterface<string>> {
        const url: string = this._baseUrlPaymentSupplierUpdate + 'Masive';
        return this.http.patch<RespInterface<string>>(`${url}`, payload);
    }

}